<template>
  <footer class="border-t border-black/5 bg-white py-12 px-6">
    <div
      class="mx-auto flex max-w-[1280px] flex-col items-center justify-between gap-8 md:flex-row"
    >
      <div class="flex items-center gap-4">
        <router-link to="/explorer" class="flex items-center">
          <img
            :src="require('/assets/images/mydid-logo-web.png')"
            alt="myDid"
            class="h-8 w-auto"
          />
        </router-link>
      </div>
      <nav
        class="flex flex-wrap justify-center gap-8 text-sm font-medium opacity-60"
      >
        <a
          class="hover:text-[#3b82f6] transition-colors"
          href="https://mydid.com/en/conditions-generales/"
          target="_blank"
          rel="noreferrer"
          >Terms of Service</a
        >
        <a
          class="hover:text-[#3b82f6] transition-colors"
          href="https://mydid.com/en/privacy-policy/"
          target="_blank"
          rel="noreferrer"
          >Privacy</a
        >
        <a
          class="hover:text-[#3b82f6] transition-colors"
          href="https://mydid.com/en/cookies/"
          target="_blank"
          rel="noreferrer"
          >Data Policy</a
        >
      </nav>
      <p class="text-xs opacity-40">© 2026 COMECT SAS</p>
    </div>
  </footer>
</template>
